import security from "@/main";
import Core from "@/modules/core/service/Core";
import { getApiBaseUrl } from "@/config";

const url =  {
    templates : "/api/template/filter",
    signatures: "/api/template/signatures",
    template  : "/api/template/{0}",
    variable  : "/api/template/variable",
    save      : "/api/template",
    remove    : "/api/template/{0}/deleted?on={1}"
};

export default {
    loadTemplates (customer, global, success) {
        fetch(getApiBaseUrl() + url.templates, {
            method :'POST',
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                customerId: customer === 0 ? null : customer,
                global    : global
            })
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })

    },

    create (customer) {
        console.log("create", customer)
        return Core .method.post(url.save, {
            name    : "Neue Vorlage",
            content : null,
            subject : null,
            customer: {
                id: customer === 0 ? null :customer,
            },
            standard: false
        })
    },

    remove (template) {
        return Core.method.put(url.remove, null, template.id, template.deleted)
    },

    saveTemplate (template, success) {
        fetch(getApiBaseUrl() + url.save, {
            method :'PUT',
            headers: security.jsonHeader(),
            body   : JSON.stringify(template)
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })

    },

    loadSignature (customer, success) {
        fetch(getApiBaseUrl() + url.signatures, {
            method :'POST',
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                customer: customer
            })
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })

    },

    saveSignature (signature, success) {
        fetch(getApiBaseUrl() + url.signatures, {
            method :'PUT',
            headers: security.jsonHeader(),
            body   : JSON.stringify(signature)
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })
    },

    loadVariable (success) {
        fetch(getApiBaseUrl() + url.variable, {
            method :'GET',
            headers: security.jsonHeader(),
        })
            .then(data => security.response (data))
            .then(data => {
                success (data);
            })
    },

}
